import { Box, Modal } from '@mui/material';
import { AJOList, AJOState } from 'mp-js-react-auto-json-object';
import { Button } from 'flowbite-react';
import { Component } from 'react';
import { Spinner } from '../../commun/component/Spinner';
import { JSXInternal } from 'preact/src/jsx';
import { get } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Prestation from '../../object/profile/Prestation';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { SelectPrestationList } from './SelectPrestationList';

export interface ISelectPrestationModalProps extends IBaseModalProps {
    selectList: Prestation[];
    onSelectList: (list: Prestation[]) => void;
}

export interface ISelectPrestationModalState {
    selectList: Prestation[];
    loading: boolean;
    list: AJOState<AJOList<Prestation>>;
}

export default class SelectPrestationModal extends Component<ISelectPrestationModalProps, ISelectPrestationModalState> {
    constructor(props: ISelectPrestationModalProps) {
        super(props);

        this.state = this.initState();
    }

    initState() {
        const p: ISelectPrestationModalState = {
            selectList: this.props.selectList,
            loading: false,
            list: new AJOState<AJOList<Prestation>>(new AJOList<Prestation>(Prestation)),
        };
        p.list.setUpdate((a) => {
            this.setState({
                list: a,
            });
        });
        if (this.props.open) {
            p.loading = true;
            get('/prestation/list', {}).then((res: any) => {
                this.setState({
                    loading: false,
                });
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, this.state.list, true);
                }
            });
        }
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<ISelectPrestationModalProps>,
        prevState: Readonly<ISelectPrestationModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.props.onSelectList(this.state.selectList);
                    onClose();
                }}
                title="Sélectionner des prestations"
                done="Sélectionner"
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <SelectPrestationList
                        list={this.state.list.get()!.getList()}
                        selectList={this.state.selectList}
                        onSelectList={(list) => {
                            this.setState({
                                selectList: [...list],
                            });
                        }}
                    />
                )}
            </MpModal>
        );
    }
}
